import {infoMessage} from "@/services/messages";
import storage from '../front-store';
import http from './http_client';
export const baseErrHandler = async (callback) => {
    try {
        storage.commit('setLoading', true);
        await callback();
    } catch (e) {
        console.log('api error', e);
        const msg = e?.response?.data?.message || e?.response?.data?.error?.message;
        const text = Array.isArray(msg) ? msg.join(', ') : msg;
        infoMessage(text, 'error');
    } finally {
        storage.commit('setLoading', false);
    }
};

export const updateUser = async (data) => {
    const res = await http.postAuth(`${http.apiUrl()}/users/update` , data);
    let this_user = res?.data?.user || null;
    return this_user;
};


export const updateUserRouteInfo = async (data) => {
    const res = await http.postAuth(`${http.apiUrl()}/users/update-route-info` , data);
    let this_user = res?.data?.user || null;
    return this_user;
};

export const getUserRoutesText = async () => {
    const res = await http.getAuth(`${http.apiUrl()}/users/user-routes-text`);
    return res;
}

export const generateRoute = async (data) => {
    const res = await http.postAuth(`${http.apiUrl()}/routes/new-route-generate` , data);
    return res;
};

export const storeRoute = async (data) => {
    const res = await http.postAuth(`${http.apiUrl()}/routes/new-route-store` , data);
    return res;
};

export const getRouteById = async (id) => {
    const res = await http.getAuth(`${http.apiUrl()}/routes/${id}`);
    return res;
};

export const getMobileRoutes = async (queryString = '') => {
    const res = await http.getAuth(`${http.apiUrl()}/routes-log${queryString}`);
    return res;
};

export const getMobileTripById = async (tripId) => {
    const res = await http.getAuth(`${http.apiUrl()}/routes-log/trip/${tripId}`);
    return res;
};

export const getMobileRouteById = async (id) => {
    const res = await http.getAuth(`${http.apiUrl()}/routes-log/${id}`);
    return res;
};

export const getPlannedRouteDrivenHistory = async (routeId) => {
    const res = await http.getAuth(`${http.apiUrl()}/routes/${routeId}/driven-history`);
    return res;
};

export const getVehiclesByIds = async (ids) => {
    const res = await http.postAuth(`${http.apiUrl()}/vehicles/fetch-by-ids`, {ids});
    return res;
};

export const getTrailersByIds = async (ids) => {
    const res = await http.postAuth(`${http.apiUrl()}/trailers/fetch-by-ids`, {ids});
    return res;
};

export const listRoadExclusions = async (query = '') => {
    return http.getAuth(`${http.apiUrl()}/road-exclusions${query}`);
};

export const getRoadExclusion = async (id) => {
    return http.getAuth(`${http.apiUrl()}/road-exclusions/${id}`);
};

export const createRoadExclusion = async (payload) => {
    return http.postAuth(`${http.apiUrl()}/road-exclusions`, payload);
};

export const updateRoadExclusion = async (id, payload) => {
    const axios = require('axios');
    return axios.put(`${http.apiUrl()}/road-exclusions/${id}`, payload, {
        headers: http.getAuthHeader(),
    });
};

export const resolveRoadExclusionSegment = async (lat, lng) => {
    return http.postAuth(`${http.apiUrl()}/road-exclusions/resolve-segment`, { lat, lng });
};

export const getRoadExclusionSegmentGeometry = async (segmentId) => {
    return http.getAuth(`${http.apiUrl()}/road-exclusions/segment-geometry/${encodeURIComponent(segmentId)}`);
};

export const getApplicableRoadExclusionsForMap = async (payload) => {
    return http.postAuth(`${http.apiUrl()}/road-exclusions/applicable-map`, payload);
};